export const MUI_TABLE = {
  muiTablePaperProps: {
    elevation: 0,
    sx: { background: 'transparent', borderRadius: 0 },
  },
  muiTopToolbarProps: {
    sx: {
      background: 'var(--color-surface-2)',
      borderBottom: '1px solid var(--color-border)',
      '& .MuiIconButton-root': { color: 'var(--color-muted)' },
      '& .MuiIconButton-root:hover': { color: '#4F46E5', background: 'rgba(79,70,229,0.06)' },
      '& .MuiInputBase-root': { color: 'var(--color-text)' },
      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--color-border) !important' },
    },
  },
  muiBottomToolbarProps: {
    sx: {
      background: 'var(--color-surface-2)',
      borderTop: '1px solid var(--color-border)',
      '& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiSelect-select': {
        color: 'var(--color-muted)',
        fontSize: '0.8rem',
      },
      '& .MuiIconButton-root': { color: 'var(--color-muted)' },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      background: 'var(--color-surface-3)',
      color: 'var(--color-muted)',
      borderBottom: '1px solid var(--color-border)',
      fontSize: '0.68rem',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.07em',
    },
  },
  muiTableBodyCellProps: {
    sx: {
      background: 'var(--color-surface)',
      color: 'var(--color-text)',
      borderBottom: '1px solid var(--color-surface-3)',
      fontSize: '0.875rem',
    },
  },
  muiTableBodyRowProps: {
    sx: { '&:hover td': { background: 'var(--color-surface-2) !important' } },
  },
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: {
      '& input': { color: 'var(--color-text)', fontSize: '0.875rem' },
      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--color-border)' },
      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#4F46E5' },
    },
  },
  muiPaginationProps: {
    color: 'primary',
    rowsPerPageOptions: [25, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',
  positionToolbarAlertBanner: 'bottom',
};
